<div
  class="error-message-container"
  [ngClass]="{ 'flex center w-full align-items-center justify-content-center': pageError }"
>
  <pm-icon [icon]="'error'" class="error-icon" />
  <div class="error-message ml-1 text-xs">{{ message }}</div>
</div>
